import XLSX from 'xlsx'
import DataLoading from './DataLoading'


class Trees {


  init() {

    // let workbook = XLSX.read(data, { type:"array" });
    let all = {};

    DataLoading.trees.SheetNames.forEach(sheetname => {
      let sheet  = DataLoading.trees.Sheets[sheetname]
      let json = XLSX.utils.sheet_to_json(sheet, {header:1})

      all[sheetname] = this.parseJson(json)
    })
    return all
  }


  parseJson(json) {
    let branch = []
    let line
    json.forEach(l => {
      if(l[0]) {
        if(line) branch.push(line)
        line = {}
        line.id = l[0]
        line.toplevel = true
        line.children = []
      }
      if(l[1]) {
        line.children.push({
          id: l[1],
          children: []
        })
      }

      if(l[2]) {
        line.children[line.children.length - 1].children.push({
          id: l[2]
        })
      }
    })
    branch.push(line) // the last one
    return branch
  }
}


export default new Trees()
